import { frag, el } from './dom';
import type { ToggleState, ToggleKey } from '../state/toggles';

const TOGGLE_LABELS: Array<{ key: ToggleKey; label: string }> = [
  { key: 'compareModels',    label: 'sammenlign på tvers av modeller' },
  { key: 'compareLanguages', label: 'sammenlign med engelsk' },
  { key: 'showIds',          label: 'vis token-ID-er' },
  { key: 'showCosts',        label: 'vis kostnad' }
];

export function renderChrome(root: HTMLElement, state: ToggleState): void {
  const tpl = `
    <header class="ow-chrome">
      <h1 class="ow-title"><span class="ow-colon">:</span>tokenizer</h1>
      <nav class="ow-toggles" aria-label="visningsalternativer"></nav>
    </header>
  `;
  root.replaceChildren(frag(tpl));
  const nav = root.querySelector<HTMLElement>('.ow-toggles')!;
  TOGGLE_LABELS.forEach(t => {
    const btn = el('button', {
      class: 'ow-toggle', text: t.label,
      attrs: { type: 'button', 'data-key': t.key, 'aria-pressed': 'false' }
    });
    btn.addEventListener('click', () => state.toggle(t.key));
    nav.appendChild(btn);
  });

  const buttons = nav.querySelectorAll<HTMLButtonElement>('.ow-toggle');
  state.subscribe(snap => {
    buttons.forEach(btn => {
      const on = !!snap[btn.dataset.key as ToggleKey];
      btn.classList.toggle('on', on);
      btn.setAttribute('aria-pressed', String(on));
    });
  });
}

export function renderFooter(root: HTMLElement): void {
  root.replaceChildren(frag(`
    <footer class="ow-foot">
      av Alexander Selvikvåg Lundervold · for NHH Executive · mai 2026
    </footer>
  `));
}
